/* eslint-disable react/require-default-props */

/* eslint-disable react/no-array-index-key */

import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

import ReportTableContainer from 'reports/Common/ReportTable';
import { convertRebookingReportTypeToTable } from 'reports/utils';

const RebookingTable = ({ startDate, endDate, data }) => {
  const { t } = useTranslation();

  return (
    data && (
      <ReportTableContainer
        startDate={startDate}
        endDate={endDate}
        title={t('businessReports.bookings.reBookingsTableTitle')}
        data={{
          rows: convertRebookingReportTypeToTable(data, t),
        }}
      />
    )
  );
};

export default RebookingTable;
